import { ThemeType } from "./enum";

export const ErrorMessages = {
    //LOGIN
    1000: "아이디가 존재하지 않습니다.",
    1001: "비밀번호가 일치하지 않습니다.",
    1002: "승인대기 중인 계정입니다.",
    1003: "사용중지된 계정입니다.",

    //REGISTER
    1100: "모바일 인증을 다시 해주세요.",
    1101: "문자 전송을 실패했습니다.",
    1102: "이미 등록된 전화번호 이거나 현재 사용중인 계좌번호입니다.",
    1103: "해당 코드는 유효하지 않은 추천 코드입니다.",
    1104: "모바일 인증을 다시 해주세요.",
    1105: "현재 회원가입이 불가합니다.",
    1106: "이미 존재하는 번호입니다.",
    1107: "이미 유저에게 추천받은 유저입니다. 다른 유저를 추천할 수 없습니다.",
    1108: "등록되지 않은 번호입니다.",
    1109: "모바일 인증이 없이 회원가입이 가능합니다.",
    1110: "해당 계좌번호는 등록이 불가합니다.",

    //UPDATE
    1200: "비밀번호 수정이 불가합니다.",
    1201: "출금 비밀번호 수정이 불가합니다.",
    1202: "계좌 정보 수정이 불가합니다.",
    1203: "출금 비밀번호가 일치하지 않습니다.",
    1204: "전화번호가 일치하지 않습니다.",

    //SPORT
    2000: "스포츠 타입이 존재하지 않습니다.",
    2001: "픽스쳐 아이디가 없습니다.",
    2002: "해당 ID의 픽스쳐가 없습니다.",

    3000: "휴면계정입니다. 고객센터로 문의해주세요.",
    30001: "카지노 베팅을 할수없습니다 고객센터로 문의 바랍니다.",
    30002: "슬롯게임을 이용할수없습니다 고객센터로 문의 바랍니다.",
    30003: "카드게임을 이용할수없습니다 고객센터로 문의 바랍니다.",
    30004: "미니게임을 이용할수없습니다 고객센터로 문의 바랍니다.",
    30005: "스포츠 베팅을 할수없습니다 고객센터로 문의 바랍니다.",
    30006: "가상스포츠 배팅을 할수없습니다.",

    //SPORTBET
    3001: "보유금액이 부족합니다.",
    3002: "최소배당금 이상 베팅해주세요.",
    3003: "베팅이 불가한 마켓입니다.",
    3004: "해당 경기에 베팅이 불가합니다.",
    3005: "해당 마켓은 이미 종료되었습니다.",
    3006: "동일한 경기에 베팅이 불가합니다.",
    3007: "단폴베팅은 한개 폴더만 가능합니다.",
    3010: "베팅이 불가한 경기입니다.",
    3011: "경기가 이미 시작되어 베팅이 불가합니다.",
    3012: "베팅 금액이 적습니다.",
    3013: "베팅이 불가한 마켓입니다.",
    3014: "베팅이 불가한 경기입니다.",
    3015: "최소 단폴베팅을 확인해주세요.",
    3016: "베팅 카트가 비었습니다.",

    3017: "스포츠 프리매치 싱글 베팅은 고객님의 레벨에서 허용되지 않습니다.",
    3018: "e스포츠 프리매치 베팅은 고객님의 레벨에서 허용되지 않습니다.",
    3019: "싱글 베팅을 할 수 없습니다.",
    3020: "스포츠 프리매치에 베팅을 할 수 없습니다.",
    3021: "e스포츠 프리매치에 베팅을 할 수 없습니다.",
    3022: "인플레이 베팅은 고객님의 레벨에서 허용되지 않습니다.",
    3023: "e스포츠 인플레이 베팅은 고객님의 레벨에서 허용되지 않습니다.",
    3024: "스포츠 인플레이에 베팅을 할 수 없습니다.",
    3025: "e스포츠 인플레이에 베팅을 할 수 없습니다.",
    3026: "쵀대 배당금을 초과 하였습니다.",
    3030: "2개의 폴더로 베팅할 수 없습니다.",
    3031: "3개의 폴더로 베팅할 수 없습니다.",
    3032: "4개의 폴더로 베팅할 수 없습니다.",

    3050: "베팅이 불가한 매치입니다.",

    3052: "최소 단폴베팅을 확인해주세요.",
    3053: "베팅이 불가한 마켓입니다.",
    3054: "베팅이 불가한 경기입니다.",
    3060: "베팅가능 폴더수가 초과되었습니다.",
    3061: "최대 당첨가능 금액을 초과합니다.",
    3062: "최대베팅금을 초과했습니다.",
    3080: "회원님의 베팅 내역이 아닙니다.",
    3081: "스포츠 베팅이 보류 중입니다. 삭제할 수 없습니다.",

    // cancel bet errors
    3082: "스포츠 베팅을 찾을 수 없습니다",
    3083: "스포츠 베팅이 보류 중이 아닙니다.",
    3084: "스포츠 베팅 취소 시간 초과",
    3085: "스포츠 베팅의 경기 일정은 제한되어 있으므로 베팅을 취소할 수 없습니다.",

    3090: "최대당첨금액을 초과했습니다.",
    3091: "최대당첨금을 초과했습니다.",
    3102: "가상경기를 찾을 수 없습니다.",

    //MINIBET
    3200: "보유금액이 부족합니다.",
    3201: "해당 라운드는 이미 종료되었습니다.",
    3202: "베팅이 불가한 마켓입니다.",
    3203: "베팅이 불가한 경기입니다.",
    3204: "베팅이 불가합니다.",
    3205: "최소 베팅 금액 이상 배팅해주세요.",
    3206: "최대 당첨 금액을 초과했습니다.",
    3207: "미니게임Id가 존재하지 않습니다.",
    3208: "미니게임 라운드 베팅이 마감되었습니다.",
    3209: "미니게임 라운드가 유효하지 않습니다.",
    3210: "미니게임 싱글 베팅은 고객님의 레벨에서 불가능합니다.",
    3211: "미니게임 조합 베팅은 고객님의 레벨에서 불가능합니다.",
    3212: "미니게임 베팅이 불가능합니다.",
    3214: "최대 베팅 금액을 초과했습니다.",
    3215: "동일 라운드 최대베팅횟수를 초과하였습니다.",
    3280: "회원님의 베팅이 아닙니다.",
    3281: "해당 베팅은 대기 중이며 삭제할 수 없습니다.",

    //CASINO
    3400: "주소를 받지 못했습니다. 다시 시도해주세요.",
    3401: "회원님은 현재 카지노 플레이가 불가능합니다. 관리자로 문의해주세요.",
    3402: "회원님은 현재 카지노 플레이가 불가능합니다. 관리자로 문의해주세요.",
    3505: "트랙픽이 초과 되었습니다 잠시후 다시 접속 해주시길 바랍니다.",
    //MYPAGE
    4000: "회원님의 메세지가 아닙니다.",
    4001: "메세지를 읽은 후 삭제할 수 있습니다.",

    8000: "최소입금액 이상 입금 가능합니다.",
    8001: "선택 불가한 보너스 옵션입니다. 다시 선택해주세요.",
    8002: "승인 대기중인 입금신청이 있습니다.",
    8003: "회원님의 입금 로그가 아닙니다.",
    8004: "입금 대기 중인 로그는 삭제할 수 없습니다.",
    8005: "최소 출금 단위를 확인해주시기 바랍니다.",
    8010: "최소출금액 이상 출금 가능합니다.",
    8011: "롤링금액이 충분하지 않아 출금이 불가능합니다.",
    8012: "요청하신 출금액이 보유금액보다 큽니다.",
    8013: "승인 대기중인 출금신청이 있습니다.",
    8014: "출금 비밀번호가 일치하지 않습니다.",
    8015: "회원님의 출금 로그가 아닙니다.",
    8016: "출금 대기중인 로그는 삭제할 수 없습니다.",
    8017: "회원님은 현재 출금이 불가능합니다. 관리자로 문의해주세요.",
    8018: "출금 요청 횟수가 초과되었습니다.",
    8019: "재출금 요청은 잠시후 다시 시도해주세요.",
    8027: "카지노머니 전환이 불가능합니다, 고객센터로 문의 해주세요.",
    8028: "일일 출금 한도를 초과했습니다. 고객센터로 문의 해주세요.",
    8029: "고객센터로 문의 바랍니다.",
    8031: "은행 점검시간 중에는 출금이 불가능합니다.",
    8020: "최소 전환금액 이상 전환가능합니다.",
    8021: "캐쉬가 충분하지 않습니다.",
    8022: "카지노머니 전환이 불가능합니다, 고객센터로 문의 해주세요.",
    8023: "현금에서 카지노로 전환이 불가합니다.",
    8024: "회원님의 전환 로그가 아닙니다.",
    8030: "1회 출금 최대 금액이 초과되었습니다.",
    8500: "최소 전환금액 이상 전환가능합니다.",
    8501: "포인트가 충분하지 않습니다.",
    8502: "회원님의 포인트 로그가 아닙니다.",

    9000: "문의 파일 업로드를 실패했습니다.",
    9001: "회원님의 문의가 아닙니다.",
    9002: "요청이 대기 중이므로 문의를 삭제할 수 없습니다.",
    9003: "대기중인 문의가 있습니다. 새 문의를 생성할 수 없습니다.",

    // COUPON ROLLING
    9513: "쿠폰 롤링 요건을 충족하지 않아 출금할 수 없습니다.",
};

export const BankNames = ["국민", "농협", "신한", "카카오뱅크", "우리", "하나", "IBK기업", "SC제일", "신협", "수협"];

//동행 파워볼
const betData1 = [
    {
        category: "일반볼 홀짝",
        code: 1,
        item: [
            { name: "일반볼 - 홀", id: 1, odds: 1.95 },
            { name: "일반볼 - 짝", id: 2, odds: 1.95 },
        ],
    },

    {
        category: "파워볼 홀짝",
        code: 2,
        item: [
            { name: "파워볼 - 홀", id: 3, odds: 1.95 },
            { name: "파워볼 - 짝", id: 4, odds: 1.95 },
        ],
    },

    {
        category: "일반볼 오버/언더",
        code: 3,
        item: [
            { name: "일반볼 - 오버", id: 5, odds: 1.95 },
            { name: "일반볼 - 언더", id: 6, odds: 1.95 },
        ],
    },

    {
        category: "파워볼 오버/언더",
        code: 4,
        item: [
            { name: "파워볼 - 오버", id: 7, odds: 1.95 },
            { name: "파워볼 - 언더", id: 8, odds: 1.95 },
        ],
    },

    {
        category: "일반볼 홀짝 + 소/중/대",
        code: 5,
        item: [
            { name: "일반볼 - 홀+대", id: 9, odds: 4.4 },
            { name: "일반볼 - 홀+중", id: 10, odds: 4.2 },
            { name: "일반볼 - 홀+소", id: 11, odds: 4.4 },
            { name: "일반볼 - 짝+대", id: 12, odds: 4.4 },
            { name: "일반볼 - 짝+중", id: 13, odds: 4.2 },
            { name: "일반볼 - 짝+소", id: 14, odds: 4.4 },
        ],
    },

    {
        category: "일반볼 소/중/대",
        code: 6,
        item: [
            { name: "일반볼 - 소(15-64)", id: 15, odds: 2.75 },
            { name: "일반볼 - 중(65-80)", id: 16, odds: 2.35 },
            { name: "일반볼 - 대(81-130)", id: 17, odds: 2.75 },
        ],
    },
];

//2. 엔트리파워사다리
//3. 엔트리키노사다리
const betData2 = [
    {
        category: "홀짝",
        code: 1,
        item: [
            { name: "홀", id: 1, odds: 1.95 },
            { name: "짝", id: 2, odds: 1.95 },
        ],
    },

    {
        category: "좌/우 출발",
        code: 2,
        item: [
            { name: "좌 출발", id: 3, odds: 1.95 },
            { name: "우 출발", id: 4, odds: 1.95 },
        ],
    },

    {
        category: "3줄/4줄",
        code: 3,
        item: [
            { name: "3줄", id: 5, odds: 1.95 },
            { name: "4줄", id: 6, odds: 1.95 },
        ],
    },

    {
        category: "좌/우 + 3줄/4줄 + 홀짝",
        code: 4,
        item: [
            { name: "좌4홀", id: 7, odds: 3.6 },
            { name: "우3홀", id: 8, odds: 3.6 },
            { name: "좌3짝", id: 9, odds: 3.6 },
            { name: "우4짝", id: 10, odds: 3.6 },
        ],
    },
];

//4. 메타3분
const betData3 = [
    {
        category: "일반볼 홀짝",
        code: 1,
        item: [
            { name: "일반볼 - 홀", id: 1, odds: 1.95 },
            { name: "일반볼 - 짝", id: 2, odds: 1.95 },
        ],
    },

    {
        category: "파워볼 홀짝",
        code: 2,
        item: [
            { name: "파워볼 - 홀", id: 3, odds: 1.95 },
            { name: "파워볼 - 짝", id: 4, odds: 1.95 },
        ],
    },

    {
        category: "일반볼 오버/언더",
        code: 3,
        item: [
            { name: "일반볼 - 오버", id: 5, odds: 1.95 },
            { name: "일반볼 - 언더", id: 6, odds: 1.95 },
        ],
    },

    {
        category: "파워볼 오버/언더",
        code: 4,
        item: [
            { name: "파워볼 - 오버", id: 7, odds: 1.95 },
            { name: "파워볼 - 언더", id: 8, odds: 1.95 },
        ],
    },

    {
        category: "일반볼 홀짝 + 오버/언더",
        code: 5,
        item: [
            { name: "일반볼 - 홀+언더", id: 9, odds: 3.7 },
            { name: "일반볼 - 홀+오버", id: 10, odds: 3.7 },
            { name: "일반볼 - 짝+언더", id: 11, odds: 3.7 },
            { name: "일반볼 - 짝+오버", id: 12, odds: 3.7 },
        ],
    },

    {
        category: "일반볼 홀짝 + 소/중/대",
        code: 6,
        item: [
            { name: "일반볼 - 홀+대", id: 13, odds: 4.4 },
            { name: "일반볼 - 홀+중", id: 14, odds: 4.2 },
            { name: "일반볼 - 홀+소", id: 15, odds: 4.4 },
            { name: "일반볼 - 짝+대", id: 16, odds: 4.4 },
            { name: "일반볼 - 짝+중", id: 17, odds: 4.2 },
            { name: "일반볼 - 짝+소", id: 18, odds: 4.4 },
        ],
    },

    {
        category: "파워볼 홀짝 + 오버/언더",
        code: 7,
        item: [
            { name: "파워볼 - 홀+언더", id: 19, odds: 4.12 },
            { name: "파워볼 - 홀+오버", id: 20, odds: 3.02 },
            { name: "파워볼 - 짝+언더", id: 21, odds: 3.02 },
            { name: "파워볼 - 짝+오버", id: 22, odds: 4.12 },
        ],
    },

    {
        category: "파워볼 + 일반볼",
        code: 8,
        item: [
            { name: "파워볼 홀 + 일반볼 홀", id: 23, odds: 3.2 },
            { name: "파워볼 홀 + 일반볼 짝", id: 24, odds: 3.2 },
            { name: "파워볼 짝 + 일반볼 홀", id: 25, odds: 3.2 },
            { name: "파워볼 짝 + 일반볼 짝", id: 26, odds: 3.2 },
        ],
    },
];

export const suremanGameIds = [22, 23, 24, 25, 26, 27, 28, 29, 30];

export const powerballGameIds = [4, 5, 6, 7, 8, 9, 10, 21, 25, 26, 27, 31, 32, 33, 34, 41, 50];
export const ladarGameIds = [11, 12, 22, 23, 24, 35, 37, 40, 51];
export const racingGameIds = [28, 29, 30];
export const powerballBlueBetIds = [1, 3, 5, 7, 9, 10, 13, 14, 15, 19, 20, 23, 24];
export const ladarBlueBetIds = [1, 3, 5, 7, 8];
export const racingBlueBetIds = [1, 3];
export const speedkenoBaccaratBetIds = [36, 38, 39];
// export const barracatGameIds = [38];
// export const ringGameIds = [39];

export const SampleDomains = ["sportv2.sport-radar.watch", "sportv2.radar-sample.com"];
// export const Domains = [
//   {
//     site_code: 'arte',
//     domains: ['ate-100.com', 'ate-101.com', 'ate-102.com', 'ate-103.com'],
//     theme: ThemeType.SAMPLE2,
//     title: 'Arte'
//   },
//   {
//     site_code: 'armour',
//     domains: ['amp-02.com'],
//     theme: ThemeType.SAMPLE5,
//     title: 'Armourpick'
//   },
//   {
//     site_code: 'bd',
//     domains: ['bd-98.com'],
//     theme: ThemeType.SAMPLE52,
//     title: '청룡'
//   },
// ]

export const ArteMainMarkets = [
    {
        sports: [6046, 35232, 35709],
        markets: [1, 2, 3],
    },
    {
        sports: [48242, 154914, 131506],
        markets: [226, 342, 28],
    },
    {
        sports: [54094],
        markets: [52, 201, 166],
    },
    {
        sports: [154830, 265917, 1149093],
        markets: [52, 2, 1558],
    },
    {
        sports: [154919],
        markets: [52, 29],
    },
    {
        sports: [452674],
        markets: [52],
    },
];

// 스포츠 로고 매핑 테이블
export const SportLogos: Record<number, string> = {
    6046: "2c7bdd01-46b5-4ba8-90a6-9ab874f40f04.png", // 축구
    35232: "b6f437a4-f267-4166-a405-bca3796386a1.png", // 아이스 하키
    35709: "0ae54beb-9481-435f-9c42-692da469cd98.png", // 핸드볼
    48242: "2dbb7ac2-2f96-466c-a535-0a5a3fd241d2.png", // 농구
    154914: "292f18d4-b4a5-490f-9092-3f9043de562b.png", // 야구
    154830: "6bfb864b-4bc0-4153-a00d-b8b817b9561f.png", // 배구
    265917: "5a04793b-1109-4c84-be9c-54fd6f114b1f.png", // 탁구
    687890: "2fd1752f-3640-48e0-88e1-7f62cfce8e11.png", // E-스포츠
    131506: "044eb1a7-b09d-495b-8932-a05e5ff47659.png", // 미식축구
};
